import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { isSeller, isAuthed, getCurrentUser } from "../../services/auth.service";
import { ArrowLeft, Calendar, Clock, DollarSign, User, Building, Mail, Phone, CheckCircle } from "lucide-react";
import { getPublicUserProfile, checkHasPaymentMethod, createBuyerDemo, addSellerRecommendationStatus, addDemoMessages, saveDemoAvailableTimes, saveDemoAvailableTimesForStandalone, addSellerRole, createSellerForm } from "../../utils/api";
import iconCompanyDefault from '../../assets/companylogos/default.png';
import { zonedTimeToUtc, utcToZonedTime, format } from 'date-fns-tz';
import PaymentMethod from "../account/PaymentMethod";

const getDayOfWeek = (date) => {
  // Convert to 1-7 where 1 is Monday
  let day = date.getDay();
  return day === 0 ? 7 : day;
};

const formatTimeFromMinutes = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const period = hours >= 12 ? 'PM' : 'AM';
  // Convert 24h to 12h format
  const hour12 = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
  const formattedHour = hour12.toString();
  const formattedMinutes = mins.toString().padStart(2, '0');
  return `${formattedHour}:${formattedMinutes} ${period}`;
};

const convertTimezone = (date, fromTz, toTz) => {
  const fromOffset = new Date().toLocaleString('en-US', { timeZone: fromTz, timeZoneName: 'short' })
    .split(' ').pop();
  const toOffset = new Date().toLocaleString('en-US', { timeZone: toTz, timeZoneName: 'short' })
    .split(' ').pop();

  // Get UTC time by adding the source timezone offset
  const utcDate = new Date(date.getTime() + (getTimezoneOffset(fromOffset) * 60000));

  // Convert to target timezone
  return new Date(utcDate.getTime() - (getTimezoneOffset(toOffset) * 60000));
};

const getTimezoneOffset = (tzString) => {
  const match = tzString.match(/([+-])(\d{2})(\d{2})/);
  if (!match) return 0;
  const [_, sign, hours, minutes] = match;
  return (sign === '+' ? 1 : -1) * (parseInt(hours) * 60 + parseInt(minutes));
};

const DemoRequestFromSeller = () => {
  const { buyerId } = useParams();
  const [showRegistrationDialog, setShowRegistrationDialog] = useState(false);
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]); // Will now store Date objects
  const [vendorMessage, setVendorMessage] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  let { slug } = useParams();
  const [buyer, setBuyer] = useState({});
  const [userProfile, setUserProfile] = useState({});
  const [user_id, setUserId] = useState('');
  const [user_slug, setUserSlug] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [biography, setBiography] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [showSaveBanner, setShowSaveBanner] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]);
  const [hasPaymentMethod, setHasPaymentMethod] = useState(false);
  const [loadedPaymentMethod, setLoadedPaymentMethod] = useState(false);
  const [buyerTimezone, setBuyerTimezone] = useState('');
  const [signupEmail, setSignupEmail] = useState('');
  const [signupPassword, setSignupPassword] = useState('');
  const [signupCompanyName, setSignupCompanyName] = useState('');
  const [signupName, setSignupName] = useState('');
  const [showCreditCardForm, setShowCreditCardForm] = useState(false);
  const [cardNumber, setCardNumber] = useState('');
  const [cardExpiry, setCardExpiry] = useState('');
  const [cardCvc, setCardCvc] = useState('');
  const [currentUser, setCurrentUser] = useState(null);
  const [loadedUser, setLoadedUser] = useState(false);
  const visitorTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const baseImageUrl = process.env.REACT_APP_BASE_IMAGE_URL;
  const imageUrl = process.env.REACT_APP_IMAGE_URL;

  useEffect(() => {
    async function loadCurrentUser() {
      const user = getCurrentUser();
      setCurrentUser(user);
      setLoadedUser(true);
    }

    async function loadPaymentCheck() {
      let res = await checkHasPaymentMethod();

      if (res.success) {
        setHasPaymentMethod(res.data);
        setLoadedPaymentMethod(true);
      }

      else{

      }
    }

    async function loadUserProfile() {
      if (user_slug && user_slug !== '') {
        slug = user_slug;
      }

      let res = await getPublicUserProfile(slug);

      if (res.success) {
        if (res.data){
        setBuyer(res.data);
        setUserProfile(res.data);
        setJobTitle(res.data.job_title);
        setFirstName(res.data.first_name);
        setLastName(res.data.last_name);
        setBiography(res.data.biography);
        setBuyerTimezone(res.data.timezone);
        setLoaded(true);
        }
      }

      else{
        // show an error message or redirect
        setLoaded(true);
      }
    }

    loadCurrentUser();
    loadPaymentCheck();
    loadUserProfile();
  }, []);

  // Helper to increment custom HHMM format by 30 minutes
function add30Min(timeInt) {
  let hour = Math.floor(timeInt / 100);
  let minute = timeInt % 100;

  minute += 30;
  if (minute >= 60) {
    hour += 1;
    minute -= 60;
  }

  return hour * 100 + minute;
}

  useEffect(() => {
    if (!userProfile.work_hours || !userProfile.timezone) return;

   const generateTimeSlots = () => {
  const slots = [];
  const now = new Date();
  const nextTwoWeeks = new Date(now.getTime() + (5 * 24 * 60 * 60 * 1000));

  for (let date = new Date(now); date <= nextTwoWeeks; date.setDate(date.getDate() + 1)) {
    const dayOfWeek = getDayOfWeek(date);
    const workHours = userProfile.work_hours.find(
      wh => wh.day_of_week === dayOfWeek && wh.is_active
    );


    if (workHours) {
      let time = workHours.start_time;

    while (time <= workHours.end_time - 1) {
      const hour = Math.floor(time / 100);
      const minute = time % 100;

        const dateStr = format(date, 'yyyy-MM-dd'); // Uses date-fns format (no time info leakage)
const localDateStr = `${dateStr} ${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:00`;


        // Convert from buyer's timezone to UTC
        const slotUtc = zonedTimeToUtc(localDateStr, userProfile.timezone);

        // Convert UTC to visitor's timezone for display
        const zone = visitorTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
        const slotInVisitorZone = utcToZonedTime(slotUtc, zone);

        if (slotInVisitorZone > now) {
          slots.push({
            id: `${slotUtc.toISOString()}-${time}`,
            date: format(slotInVisitorZone, 'EEE, MMM dd, yyyy'),
            time: format(slotInVisitorZone, 'hh:mm aaaa'),
            timezone: zone,
            buyerDateTime: format(slotUtc, 'yyyy-MM-dd HH:mm'), // in UTC, for trace/debug
            buyerTimezone: userProfile.timezone,
            available: true,
            originalTime: slotUtc, // UTC to be sent to API
            localDateStr: localDateStr, // Local date string for debugging
          });
        }
              time = add30Min(time);

      }
    }
  }

      setTimeSlots(slots);
    };

    generateTimeSlots();
  }, [userProfile.work_hours, userProfile.timezone]);

  const handleTimeSlotChange = (e, slotId, slot) => {
    
    setSelectedTimeSlots(prev => {
      // Find if there's already a Date that matches this slot's original time
      const exists = prev.some(date => 
        date.getTime() === slot.originalTime.getTime()
      );

      if (exists) {
        return prev.filter(date => 
          date.getTime() !== slot.originalTime.getTime()
        );
      }
      return [...prev, slot.originalTime];
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedTimeSlots.length === 0) {
      return;
    }

    if (isAuthed() == false && signupEmail === '') {
      alert('Please enter your email to continue.');
      return;
    }

    if (isAuthed() == false && signupPassword === '') {
      alert('Please enter your full name to continue.');
      return;
    }

    setSubmitting(true);

    if (isAuthed() == false) {
      if (!showCreditCardForm) {
        // First submission - show credit card form
        setShowCreditCardForm(true);
        setSubmitting(false);
        return;
      } else {
        // Credit card form submitted
        if (!cardNumber || !cardExpiry || !cardCvc) {
          alert('Please fill in all credit card details');
          setSubmitting(false);
          return;
        }
        setIsSubmitted(true);
        setSubmitting(false);
        return;
      }
    }

    try {
      let res = await addSellerRecommendationStatus(buyer.registered_user_id, 'Approved', 'Buyer Directory');

      if (res.success) {
        let data2 = { buyer_id: userProfile.registered_user_id, credit_cost: 5, message: 'Standalone Demo Request', is_standalone: true };
        let res2 = await createBuyerDemo(data2);
        let refid = res2.data;
        let demo_id = res2.demo_id;

        await saveDemoAvailableTimesForStandalone(demo_id, selectedTimeSlots, visitorTimezone);

        if (vendorMessage.length > 0)
          await addDemoMessages(refid, vendorMessage);

        if (isSeller() == false){
          await addSellerRole();
        }
      }

      setIsSubmitted(true);
    } catch (error) {
      console.error('Error submitting demo request:', error);
    } finally {
      setSubmitting(false);
    }
  };

    function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    let _domain = 'domain=leadrpro.com';
    document.cookie = cname + '=' + cvalue + ';' + _domain + ';' + expires + ';path=/';
  }

  async function handleCreateAccount(){
    let data = {
      email: signupEmail,
      password: signupPassword,
      first_name: userProfile.first_name,
      last_name: userProfile.last_name,
      company_name: signupCompanyName,
    };
    let res = await createSellerForm(data);

    if (res.success){
            localStorage.setItem('access_token', res.data.accessToken);
            localStorage.setItem('refresh_token', res.data.refreshToken);

            setCookie('access_token', res.data.accessToken, 1);
            window.location = window.location;
            // setShowConfirmation(true);
            // setLoading(false);
            // setSubmitting(false);
        }

        else{
          alert(res.message);
            //setLoading(false);
        //    setErrorMessage(res.error);
            //setShowError(true);
            //setSubmitting(false);
        }
  }

  if (loaded && (!userProfile || !userProfile.first_name)) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="w-full max-w-md text-center bg-white rounded-lg border border-gray-200 shadow-md p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Profile Not Found</h2>
          <p className="text-gray-600 mb-6">
            The user profile you are looking for could not be found.
          </p>
          <Link to="/dashboard/seller">
            <button className="w-full bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors">
              Return to Dashboard
            </button>
          </Link>
        </div>
      </div>
    );
  }

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="w-full max-w-md text-center bg-white rounded-lg border border-gray-200 shadow-md p-6">
          <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Request Sent!</h2>
          <p className="text-gray-600 mb-6">
            Your meeting request has been sent to {userProfile.first_name} {userProfile.last_name}. You'll receive a confirmation email once they accept.
          </p>
          <div className="space-y-3 text-sm text-gray-500 mb-6">
            <p>• Payment will be processed when the meeting is confirmed</p>
            <p>• You can reschedule up to 24 hours before the meeting</p>
            <p>• Meeting link will be sent via email</p>
          </div>
          <Link to="/dashboard/seller">
            <button className="w-full bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors">
              Return to Dashboard
            </button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Registration Dialog */}
      {showRegistrationDialog && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative">
            <button
              onClick={() => setShowRegistrationDialog(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-500"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="text-center mb-6">
              <h3 className="text-lg font-medium text-gray-900">Create your account</h3>
              <p className="mt-1 text-sm text-gray-500">
                Already have an account?{' '}
                <Link to={`/login?redirect_url=${encodeURIComponent(window.location.pathname)}`} className="text-blue-600 hover:underline">
                  Log in
                </Link>
              </p>
            </div>

            <div className="space-y-4">
              <div>
                <label htmlFor="signup-name-dialog" className="block text-sm font-medium text-gray-700">Full Name</label>
                <input
                  type="text"
                  id="signup-name-dialog"
                  value={signupName}
                  onChange={(e) => setSignupName(e.target.value)}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label htmlFor="signup-email-dialog" className="block text-sm font-medium text-gray-700">Email Address</label>
                <input
                  type="email"
                  id="signup-email-dialog"
                  value={signupEmail}
                  onChange={(e) => setSignupEmail(e.target.value)}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label htmlFor="signup-company-dialog" className="block text-sm font-medium text-gray-700">Company Name</label>
                <input
                  type="text"
                  id="signup-company-dialog"
                  value={signupCompanyName}
                  onChange={(e) => setSignupCompanyName(e.target.value)}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label htmlFor="signup-password-dialog" className="block text-sm font-medium text-gray-700">Password</label>
                <input
                  type="password"
                  id="signup-password-dialog"
                  value={signupPassword}
                  onChange={(e) => setSignupPassword(e.target.value)}
                  className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                  required
                />
              </div>

              <button
                type="button"
                onClick={() => handleCreateAccount()}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Sign up and continue
              </button>

              <p className="text-xs text-gray-500 text-center">
                By signing up, you agree to our Terms of Service and Privacy Policy.
              </p>
            </div>
          </div>
        </div>
      )}
      
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="mx-auto px-4 py-4 max-w-6xl">
          <div className="flex items-center gap-4">

            <div className="h-6 w-px bg-gray-300"></div>
            <h1 className="text-xl font-semibold text-gray-900">Request Meeting</h1>
          </div>
        </div>
      </div>

      <div className="mx-auto px-4 py-2 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

          {/* Buyer Profile */}
          <div className="lg:col-span-1 space-y-6">
            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
              <div className="flex items-center gap-4 mb-4">
                <div className="h-24 w-24 rounded-full border-4 border-white shadow overflow-hidden flex items-center justify-center bg-purple-100 text-purple-700">
                  {userProfile.profile_image && userProfile.profile_image !== '' && (
                    <img src={baseImageUrl + 'profileimages/' + userProfile.profile_image} alt="logo found" className='h-full w-full object-cover' />
                  )}

                  {(!userProfile.profile_image || userProfile.profile_image === '') && (
                    <img src={iconCompanyDefault} className='h-full w-full object-cover' alt="logo not found" />
                  )}
                </div>

                <div>
                  <h2 className="text-xl font-bold text-gray-900">{userProfile.first_name} {userProfile.last_name}</h2>
                  <p className="text-gray-600">{userProfile.job_title}</p>
                  <p className="text-blue-600 font-medium">{userProfile.company_name}</p>
                </div>
              </div>

              <div className="space-y-3 text-sm">
                <div className="flex items-center gap-2">
                  <Building className="h-4 w-4 text-gray-500" />
                  <span>{userProfile.company_size} • {userProfile.industry}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Mail className="h-4 w-4 text-gray-500" />
                  <span>{userProfile.country_name}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Clock className="h-4 w-4 text-gray-500" />
                  <span className="text-green-600">{userProfile.timezone}</span>
                </div>
              </div>

              <div className="mt-4 pt-4 border-t border-gray-200">
                <p className="text-sm text-gray-600">{userProfile.biography}</p>
              </div>
            </div>

            {/* Pricing Info */}
            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
              <div className="flex items-center gap-3 mb-4">
                <DollarSign className="h-6 w-6 text-green-600" />
                <h3 className="text-lg font-semibold text-gray-900">Meeting Pricing</h3>
              </div>

              <div className="bg-green-50 rounded-lg p-4 border border-green-200">
                <div className="text-center">
                  {loadedUser == true && loaded == true && (
                  <div className="text-3xl font-bold text-green-700">
                    {currentUser && userProfile && currentUser.registered_user_id === userProfile.registered_user_id ? '$75' : '$100'}
                  </div>
                  )}
                  <div className="text-sm text-green-600">per 30-45 minute session</div>
                </div>
              </div>

              <div className="mt-4 space-y-2 text-sm text-gray-600">
                <div className="flex justify-between">
                  <span>Duration:</span>
                  <span className="font-medium">30-45 minutes</span>
                </div>
                <div className="flex justify-between">
                  <span>Format:</span>
                  <span className="font-medium">Video call</span>
                </div>
                <div className="flex justify-between">
                  <span>Payment:</span>
                  <span className="font-medium">After confirmation</span>
                </div>
              </div>

              <div className="mt-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
                <p className="text-xs text-blue-800">
                  <strong>What's included:</strong> Product demo, Q&A session, implementation guidance, and follow-up resources.
                </p>
              </div>
            </div>
          </div>

          {/* Meeting Request Form */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-lg border border-gray-200 shadow-md">
              <div className="border-b border-gray-200 p-6">
                <h3 className="text-2xl font-semibold text-gray-900 flex items-center gap-2">
                  <Calendar className="h-6 w-6 text-blue-600" />
                  Schedule Your Meeting
                </h3>
                <p className="text-gray-600 mt-2">
                  Select a time slot and provide details about your product and meeting objectives.
                </p>
              </div>

              <div className="p-6 relative overflow-auto">
                <form onSubmit={handleSubmit} className="space-y-6">

                  {/* Time Slot Selection */}
                  <div className="relative">
                    <h4 className="text-lg font-medium text-gray-900 mb-2">Available Time Slots</h4>
                    <p className="text-sm text-gray-600 mb-4">
                      Please select at least 3 preferred time slots to increase the likelihood of finding a suitable meeting time.
                    </p>
                    {!isAuthed() && (
                      <div className="absolute inset-0 bg-white/60 backdrop-blur-sm flex items-center justify-center z-10">
                        <div className="text-center">
                          <h3 className="text-lg font-semibold text-gray-900 mb-2">Create an Account to Book</h3>
                          <p className="text-sm text-gray-600 mb-4">Sign up to view and select available time slots</p>
                          <button
                            onClick={() => setShowRegistrationDialog(true)}
                            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          >
                            Create Account
                          </button>
                        </div>
                      </div>
                    )}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-h-[400px] overflow-y-auto p-1">
                      {timeSlots.map((slot) => (
                        <div key={slot.id}>
                          <input
                            type="checkbox"
                            id={`slot-${slot.id}`}
                            name="timeSlot"
                            value={slot.id}
                            checked={selectedTimeSlots.some(date => 
                              date.getTime() === slot.originalTime.getTime()
                            )}
                            onChange={(e) => handleTimeSlotChange(e, slot.id, slot)}
                            disabled={!slot.available}
                            className="sr-only"
                          />
                          <label
                            htmlFor={`slot-${slot.id}`}
                            className={`block p-3 rounded-lg border cursor-pointer transition-colors ${selectedTimeSlots.some(date => 
                                date.getTime() === slot.originalTime.getTime()
                              )
                                ? 'border-blue-500 bg-blue-50 text-blue-700'
                                : slot.available
                                  ? 'border-gray-300 hover:border-gray-400 bg-white'
                                  : 'border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed'
                              }`}
                          >
                            <div className="font-medium">{slot.date}</div>
                            <div className="text-sm">Your time: {slot.time} ({slot.timezone})</div>
                            <div className="text-sm text-gray-500">
                              Other's time: {slot.localDateStr} ({slot.buyerTimezone})
                            </div>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-900 mb-2">
                      Meeting Request Message *
                    </label>
                    <textarea
                      id="message"
                      value={vendorMessage}
                      onChange={(e) => setVendorMessage(e.target.value)}
                      placeholder="Describe your product, what you'd like to discuss, and your specific goals for this meeting..."
                      rows={5}
                      required
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />

                  </div>

                  {/* Summary */}
                  {selectedTimeSlots.length > 0 && (
                    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                      <h4 className="font-medium text-gray-900 mb-2">Meeting Summary</h4>
                      <div className="space-y-1 text-sm text-gray-600">
                        <div>
                          <strong>Buyer:</strong> {userProfile.first_name} {userProfile.last_name} ({userProfile.company_name})
                        </div>
                        <div className="space-y-1">
                          <strong>Selected Times:</strong>
                          {selectedTimeSlots.map(date => (
                            <div key={date.getTime()} className="ml-4">
                              • {date.toLocaleDateString()} at {formatTimeFromMinutes(date.getHours() * 60 + date.getMinutes())} {visitorTimezone}
                            </div>
                          ))}
                        </div>

                      </div>
                    </div>
                  )}

                  {hasPaymentMethod && (
                    <>
                      <div className="mb-4 p-3 bg-blue-50 rounded border border-blue-200">
                        <p className="text-sm text-blue-800">
                          <strong>Payment Note:</strong> Your payment method will only be charged after the meeting has been approved and completed successfully.
                        </p>
                      </div>
                      <button
                        type="submit"
                        disabled={submitting}
                        className="w-full bg-blue-600 text-white px-4 py-3 rounded-md hover:bg-blue-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                      >
                        {submitting ? (
                          <>
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Submitting Request...
                          </>
                        ) : (
                          'Request Meeting'
                        )}
                      </button>
                    </>
                  )}

                  {!hasPaymentMethod && loadedPaymentMethod && (
                    <div className="text-red-600 text-sm">
                      You must have a payment method on file to request a meeting.

                      <div className="mt-2">
                        <Link to={`/account/payment-method?redirect_url=${encodeURIComponent(window.location.pathname)}`} className="text-blue-600 hover:underline">
                          Add Payment Method
                        </Link>
                      </div>

                      <div className="mt-4 p-3 bg-gray-50 rounded border border-gray-200">
                        <p className="text-gray-600 text-sm">
                          <strong>Note:</strong> You will not be charged until after the demo has been booked and completed successfully.
                        </p>
                      </div>
                    </div>
                  )}



                  {/* {isAuthed() == false && showCreditCardForm && (
                    <div className="space-y-6 border-t border-gray-200 pt-6">
                      <div className="text-center">
                        <h3 className="text-lg font-medium text-gray-900">Add Payment Method</h3>
                        <p className="mt-1 text-sm text-gray-500">
                          Your card will only be charged after the meeting is completed
                        </p>
                      </div>

                      <div>
                        <PaymentMethod />
                      </div>

                      <div className="space-y-4">
                        <div>
                          <label htmlFor="card-number" className="block text-sm font-medium text-gray-700">Card Number</label>
                          <input
                            type="text"
                            id="card-number"
                            value={cardNumber}
                            onChange={(e) => setCardNumber(e.target.value)}
                            placeholder="1234 5678 9012 3456"
                            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                            required
                          />
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <label htmlFor="card-expiry" className="block text-sm font-medium text-gray-700">Expiration Date</label>
                            <input
                              type="text"
                              id="card-expiry"
                              value={cardExpiry}
                              onChange={(e) => setCardExpiry(e.target.value)}
                              placeholder="MM/YY"
                              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                              required
                            />
                          </div>

                          <div>
                            <label htmlFor="card-cvc" className="block text-sm font-medium text-gray-700">CVC</label>
                            <input
                              type="text"
                              id="card-cvc"
                              value={cardCvc}
                              onChange={(e) => setCardCvc(e.target.value)}
                              placeholder="123"
                              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                              required
                            />
                          </div>
                        </div>

                        <button
                          type="submit"
                          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                          Complete Registration
                        </button>

                        <div className="mt-4 p-3 bg-gray-50 rounded border border-gray-200">
                          <p className="text-gray-600 text-sm">
                            <strong>Note:</strong> Your card will only be charged after the meeting is completed successfully.
                          </p>
                        </div>
                      </div>
                    </div>
                  )} */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoRequestFromSeller;